module.exports = __webpack_public_path__ + "assets/img/main2.70d28fb2.png";